<template>
  <div>
    <div class="sl-amap-location">
      <input class="sl-amap-input" :value="location" placeholder="请输入地址回车搜索" @keyup.enter="remoteSearch($event.target.value)" />
      <div class="sl-smap-location-value"><span>{{locationLabel}}</span><span style="color:rgba(0,0,0,.4)">拖拽标记可更改位置</span></div>
      <div class="sl-amap-location-results" v-if="showResults">
        <div class="sl-amap-location-item" v-for="item in options" @click="handleChange(item)">
          <span>{{item.label}}</span>
          <span style="float:right;color:#ccc">{{item.district}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import protoComponent from './proto'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'
import { search } from '../utils'
import { debounce } from '@/util'

const searchPoi = search//debounce(search , 200)
const latlngLabel = (p) => {
  return Math.abs(p[1]).toFixed(6)+`° ${p[1]>0 ? 'N' : 'S' }  ` + Math.abs(p[0]).toFixed(6)+`° ${p[0]>0 ? 'E' : 'W' }`
}

const createLatlng = (v , cs = 'gcj02') => {
  if (v && v[0] && v[1]) {
    let lat = parseFloat(v[1])
    let lng = parseFloat(v[0])
    if (lat && lng) {
      if (cs == 'wgs84') {
        let tmp = wgs2gcj(lng, lat)
        lat = tmp[1]
        lng = tmp[0]
      }

      return new AMap.LngLat(lng, lat)
    }
  }
}

export default {
  name: 'SlAmapLocation',
  extends: protoComponent,
  data() {
    return {
      position: '',
      options: [],
      location: '',
      oldData:[],
      marker:null,
      showResults:false,
      autoComplete: null
    }
  },
  props: {
    value: {
      type: Array,
    },
    cs: {
      type: String,
      default: 'gcj02'
    }
  },

  created(){
    this.$watch('value' , function(v){
      if (this.ready && v && v.length == 2 && (v[0] != this.oldData[0] || v[1] != this.oldData[1])) {
        this.updatePosition(v)
      }

      if(!v) this.location = ''
    })
  },
  computed:{
    locationLabel(){
      if(this.value && this.value.length == 2){
        return latlngLabel(this.value)
      }else{
        return ''
      }
    }
  },
  methods: {
    $initComponent() {

      let marker = new AMap.Marker({
        position: this.$amap.getCenter(),
        content: `<div class="sl-location-cross circle"></div>`,
        offset: new AMap.Pixel(-10, -28),
        topWhenClick:true,
        draggable:true,
      })

      marker.setMap( this.$amap )

      marker.on('dragend', this.handleMapMove.bind(this))

      this.marker = marker

      if (this.value && this.value.length == 2) {
        this.updatePosition(this.value)
      }

    },

    handleMapMove(e) {
      let center = e.target.getPosition()
      this.emit(center)
    },
    clear(){
      this.location = null
    },
    remoteSearch(key) {
      this.location = key
      if (key !== '') {
        this.loading = true;
        searchPoi(key).then(resp => {
          if (resp.count) {
            this.options = resp.tips.map(i => ({
              value: i.location,
              district: i.district,
              label: i.name
            }))
          } else {
            this.options = [];
          }
          this.loading = false;
          this.showResults = true
        })
      } else {
        this.options = [];
        this.loading = false;
        this.showResults = false;
      }
      return false
    },

    handleChange(v) {
      if (v) {
        this.location = v.label

        let p = this.updatePosition([v.value.lng , v.value.lat] , 'gcj02')

        this.emit(p)

        this.showResults = false
      }
    },

    emit(center){
      let pos = [center.lng, center.lat]

      if (this.cs == 'wgs84') {
        pos = gcj2wgs(pos[0], pos[1])
      }

      pos = pos.map(i => i.toFixed(6))

      this.position = pos

      this.oldData = [pos[0] , pos[1]]

      this.$emit('input', pos)

      this.$emit('change', pos)
    },

    updatePosition(v , cs) {
      if(!cs) cs = this.cs
      let p = createLatlng(v , cs)
      if (p && this.$amap.loaded) {
        let zoom = this.$amap.getZoom()
        if( zoom < 16) zoom = 16
        this.$amap.setZoomAndCenter(zoom , p)
        if(this.marker) this.marker.setPosition(p)
      }
      return p
    }
  }
};

</script>
<style lang='scss'>
.sl-amap-location {
  position: absolute;
  left: 3%;
  top: 2%;
  width: 50%;
  min-width: 180px;

  .sl-amap-input {
    letter-spacing: .5px;
    font-size: 13px;
    box-sizing: border-box;
    border: none;
    outline: none;
    padding: 5px;
    text-indent: 10px;
    background: #fff;
    box-shadow: 0 2px 2px rgba(0, 0, 0, .15);
    border-radius: 2px 3px 3px 2px;
    z-index: 10;
    width:100%;
    .ivu-select-selection {
      border-radius: 0;
      border: none;
      box-shadow: none;
    }
  }

  .sl-amap-location-results{
    background:#fff;
    box-shadow: 0 2px 2px rgba(0, 0, 0, .15);
    width: 100%;
    font-size: 12px;
    max-height: 200px;
    overflow-y: auto;
    position: relative;
    z-index:2;

    .sl-amap-location-item{
      padding: 0 7px;

      &:hover{
        background:rgba(0,0,0,.08);
      }
    } 
  }
}

.sl-smap-location-value {
  position: absolute;
  top: 42px;
  left: 0;
  padding:8px;
  width:100%;
  font-size:10px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0,0,0,.1);
  // border-bottom-left-radius: 4px;
  // border-radius: 2px;
  z-index:1;
  line-height: 1em;
  background:#f6f6f6;
  display: flex;
  justify-content: space-between;
}
.sl-location-cross{
  position:relative;
  line-height: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  &.circle{
    background:rgba(244,91,91,1);
    width: 20px;
    height: 20px;
    // border: 2px solid #fff;
    border-radius: 20px;
    box-shadow: 2px 2px 2px rgba(0,0,0,.15);
    color:#fff;
    font-size:11px;

    &:before{
      content: " ";

      width:0;
      height:0;
      border-left:10px solid transparent;
      border-right:10px solid transparent;
      border-top:20px solid #f45b5b;
      position: absolute;
      bottom: -8px;
      z-index: -1;
    }

    &.focus{
      animation: ease-in-out breath 2s infinite;
    }

    &.blue{
      background:rgba(61,147,253,1);

      &:before{
        border-top-color:rgba(61,147,253,1);
      }
    }
  }

}

</style>
